// extracted by mini-css-extract-plugin
export var bottomMargin = "homeTopper-module--bottomMargin--c275f";
export var content = "homeTopper-module--content--83eeb";
export var dark = "homeTopper-module--dark--06c77";
export var homeMargin = "homeTopper-module--homeMargin--cf214";
export var homeMarginVideo = "homeTopper-module--homeMarginVideo--8471b";
export var inner = "homeTopper-module--inner--389b1";
export var light = "homeTopper-module--light--820b1";
export var modalVideo = "homeTopper-module--modal-video--93f23";
export var modalVideoBody = "homeTopper-module--modal-video-body--27e05";
export var modalVideoCloseBtn = "homeTopper-module--modal-video-close-btn--02e30";
export var modalVideoEffectExit = "homeTopper-module--modal-video-effect-exit--672b7";
export var modalVideoInner = "homeTopper-module--modal-video-inner--aebdd";
export var modalVideoMovieWrap = "homeTopper-module--modal-video-movie-wrap--d7850";
export var section = "homeTopper-module--section--311e3";
export var title = "homeTopper-module--title--f6b41";
export var videoPlaceholder = "homeTopper-module--videoPlaceholder--d7132";
export var videoPlaceholderLink = "homeTopper-module--videoPlaceholderLink--bfaa1";